import React, { useState } from "react";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { ReactComponent as ExcelIcon } from "../../../../assets/icons/Excel.svg";
import { ReactComponent as PlusCircle } from "../../../../assets/icons/plus-circle.svg";
import { ReactComponent as Clip } from "../../../../assets/icons/Clip.svg";
import "../DashboardStyles.css";
import { bytesToSize, notify } from "../../../../util/helpers";
import { useDropzone } from "react-dropzone";
import { bulkPatientCSVLink } from "../../../../constants/constants";
import {
  multiInvitePatientLogic,
  invitedPatientLogic,
} from "../../../../store/features/patient/patientSlice";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};
const DragUploadComponent = ({ loading, selectedFile, setSelectedFile }) => {
  const { open, getInputProps, getRootProps } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    maxFiles: 1,
    accept: {
      "text/csv": [".csv"],
    },
    noDrag: loading,
    onDropAccepted: () => {
      //Can be used for some post-processing too
      notify("Your file is ready to be uploaded!");
    },
    onDropRejected: () => {
      notify("This file format is not supported!", "info");
    },
    onDrop: (acceptedFiles) => {
      setSelectedFile([...acceptedFiles]);
    },
  });
  return (
    <div
      className="container-fluid dragdrop-container"
      style={{ alignContent: "center", alignItems: "center" }}
    >
      {selectedFile.length > 0 ? (
        <div className="d-flex justify-content-center w-100">
          <div
            className="container bg-white p-3"
            style={{ width: "60%", borderRadius: "6px" }}
          >
            <div className="d-flex justify-content-between">
              <div className="d-flex justify-content-start w-100 container-fluid">
                <ExcelIcon fill="#0B1147" />
                <div className="container-fluid">
                  <label>{selectedFile[0]?.name}</label>
                  <div className="d-flex justify-content-between">
                    <span>{bytesToSize(selectedFile[0]?.size)}</span>
                  </div>
                </div>
              </div>
              <CloseIcon
                aria-label="Remove file"
                title="Remove file"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (loading) {
                    notify("Please wait while upload is in progress");
                    return;
                  }
                  setSelectedFile([]);
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <section {...getRootProps()}>
            <div className="container-fluid w-100 d-flex justify-content-center">
              <div
                style={{
                  backgroundColor: "#eef8ff",
                  width: "fit-content",
                  borderRadius: "100%",
                  padding: "3% 4.5%",
                }}
              >
                <Clip />
              </div>
            </div>
            <div className="d-flex justify-content-center my-3">
              <input {...getInputProps()} />
              <span
                className="muted-text"
                style={{
                  fontSize: "1.3rem",
                  width: "50%",
                  display: "block",
                  lineHeight: "26px",
                }}
              >
                Click Attach to upload or drag and drop your file
              </span>
            </div>
            <div className="d-flex justify-content-center">
              <button className="btn muted-btn" onClick={open}>
                <PlusCircle
                  fill="white"
                  style={{ marginRight: "4px", marginTop: "-2px" }}
                />{" "}
                Attach Report
              </button>
            </div>
          </section>

          <div className="d-flex justify-content-center mt-4">
            <span
              className="muted-text"
              style={{
                fontSize: "0.9rem",
                width: "90%",
                display: "block",
                lineHeight: "26px",
              }}
            >
              Kindly ensure the report to be attached is in the correct format.
              <br /> The Report columns should follow this order:
              <br />
              <strong>
                First Name, Last name, DOB, Insurance, Email, Mobile number,
                Upcoming appointment date
              </strong>
            </span>
          </div>
        </>
      )}
    </div>
  );
};

const AddBulkPatient = ({ modalIsOpen, setIsOpen }) => {
  Modal.setAppElement("#root");
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  function closeModal() {
    if (loading) {
      notify("Please wait while upload is in progress");
      return;
    }
    setSelectedFile([]);
    setIsOpen(false);
  }
  const { selectedClinic } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const handleSubmit = async (e) => {
    if (loading) {
      notify("Please wait while upload is in progress");
      return;
    }
    e.preventDefault(); //* This is redundant but just in case..
    const file = selectedFile[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("clinic", selectedClinic?.clinic?.id);
    formData.append("clinician", selectedClinic?.clinic_admin);
    setLoading(true);
    multiInvitePatientLogic(formData)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          closeModal();
          notify("Patients invited successfully!");
          dispatch(
            invitedPatientLogic({
              page_size: 999999,
              page: 1,
              status: "INVITED",
              clinic_id: selectedClinic?.clinic?.id,
              clinician_id: selectedClinic?.clinic_admin,
            })
          );
        } else {
          notify("Something went wrong! Try again later!", "error");
        }
        setLoading(false);
      })
      .catch((e) => {
        console.error(e, "REMOVE THIS LATER");
        notify("Something went wrong! Try again later!", "error");
        setLoading(false);
      });

    e.preventDefault();
  };
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <div className="container-fluid">
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 pt-2 d-flex justify-content-start">
              <h3 className="primary-text-blue">Add Bulk Patient</h3>
            </div>
            <div className="container-fluid p-1 row">
              <div className="container-fluid  mt-3">
                <DragUploadComponent
                  loading={loading}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                />
                <br />
                <div className="container-fluid d-flex justify-content-between">
                  <div
                    className="d-flex justify-content-start"
                    style={{ marginTop: "1.5%" }}
                  >
                    <a
                      href={bulkPatientCSVLink}
                      style={{
                        color: "#94a3b8",
                        userSelect: "none",
                        cursor: "pointer",
                      }}
                    >
                      <ExcelIcon fill="#94a3b8" />
                      &nbsp; Get started with this Report Template
                    </a>
                  </div>
                  <div
                    className="d-flex justify-content-end"
                    style={{ gap: "30px" }}
                  >
                    <button
                      className="btn alternative-btn"
                      style={{ padding: "10px 20px", width: "9rem" }}
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="primary-btn"
                      disabled={loading}
                      style={{ padding: "10px 20px !important", width: "9rem" }}
                    >
                      Send Invite
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default AddBulkPatient;
